import axios from 'axios'

export const transactionApi = axios.create({
    baseURL: process.env.REACT_APP_TRANSACTION_BASE_URL,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
    },
    // withCredentials: true
})